<template>
  <main style="height: 100%;">
      <header class="header-filters">
          <date-range-picker ref="datepicker" @selected="setCreatePeriodFilter"/>
      </header>
      <v-table id="table"
               :lazycount="true"
               request-uri="checks/getList"
               pagesize="50"
               @clear-table-filter="clearPlaceholder"
               ref="table">
          <template v-slot:header>
              <v-tr>
                  <v-th name="created_at" sort="competitor_checks.created_at" width="80">
                      Дата
                  </v-th>
                  <v-th name="clinic_city" sort="clinic_city" width="45">
                      Город
                  </v-th>
                  <v-th name="clinic_name" sort="clinic_name" minwidth="200">
                      Клиника
                  </v-th>
                  <v-th name="clinic_url" sort="clinic_url" minwidth="200">
                      URL
                  </v-th>
                  <v-th name="competitor_name" sort="competitor_id" width="110">
                      Конкурент
                  </v-th>
                  <v-th name="competitor_url" minwidth="200">
                      URL конкурента
                  </v-th>
                  <v-th name="has_signs_of_paid_placement" sort="has_signs_of_paid_placement" width="75">
                      Приоритет
                  </v-th>
                  <v-th name="rating" sort="rating" width="30" tooltip="Рейтинг">
                      <i class="fas fa-star-half-alt"></i>
                  </v-th>
                  <v-th name="reviews_count" sort="reviews_count" width="100">
                      Отзывов
                  </v-th>
                  <v-th name="extra_info" sort="extra_info" width="200">
                      Дополнительно
                  </v-th>
              </v-tr>

              <v-tr>
                  <v-th name="created_at" v-slot="{filter}">
                      <date-piker ref="singleDate" @change="clearDateRangePicker" v-model="filter.value"/>
                  </v-th>
                  <v-th name="clinic_city" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                      ></v-select>
                  </v-th>
                  <v-th name="clinic_name" :debounce="true" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="clinic_url" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="competitor_name" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...competitorOptions
                            ]'
                      />
                  </v-th>
                  <v-th name="competitor_url" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="has_signs_of_paid_placement" v-slot="{filter}">
                      <v-select v-model="filter.value"
                                :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Да', value: 'yes' },
                                  { text: 'Нет', value: 'no' },
                                  { text: 'Ошибка', value: 'error' },
                                ]">
                      </v-select>
                  </v-th>
                  <v-th name="rating" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "- нет"
                                },
                                {
                                    value: "1",
                                    text: "1 ★☆☆☆☆"
                                },
                                {
                                    value: "2",
                                    text: "2 ★★☆☆☆"
                                },
                                {
                                    value: "3",
                                    text: "3 ★★★☆☆"
                                },
                                {
                                    value: "4",
                                    text: "4 ★★★★☆"
                                },
                                {
                                    value: "5",
                                    text: "5 ★★★★★"
                                }
                            ]'
                      ></v-select>
                  </v-th>
                  <v-th name="reviews_count" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="extra_info" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
              </v-tr>
          </template>

          <template v-slot:row="{ item, index }">
              <v-tr class="hover">
                  <v-td name="created_at" highlight="*" width="80">
                      {{ item.created_at | formatDateTimeWithShortYearAndMonth }}
                  </v-td>
                  <v-td name="clinic_city" highlight="*" width="45">
                      <span v-if="item.clinic.cityObj !== null" v-tooltip="item.clinic.cityObj.name_info.nominative">
                          {{ item.clinic.cityObj.name_info.short }}
                      </span>
                  </v-td>
                  <v-td name="clinic_name">
                      <div>{{ item.clinic.name }}</div>
                  </v-td>
                  <v-td name="clinic_url">
                      <a class="text-ellipsis"
                         v-tooltip="`${$parent.frontendUrl}<br/>/${item.clinic.cityObj.char_id}/clinic/${item.clinic.url}`"
                         :href="`${$parent.frontendUrl}/${item.clinic.cityObj.char_id}/clinic/${item.clinic.url}`"
                         target="_blank">
                          {{ item.clinic.url }}
                      </a>
                  </v-td>
                  <v-td name="competitor_name">
                      <div>{{ item.competitor.name }}</div>
                  </v-td>
                  <v-td name="competitor_url" :tooltip="item.competitor_url">
                      <a class="text-nowrap" :href="item.competitor_url" target="_blank">
                          {{ item.competitor_url }}
                      </a>
                  </v-td>
                  <v-td name="has_signs_of_paid_placement" align="center">
                      <span v-if="item.has_signs_of_paid_placement === 1" title="Есть платное размещение">
                          <i class="fas fa-money-bills"></i>
                      </span>
                      <span v-else-if="item.has_signs_of_paid_placement == '-1'" title="Ошибка">
                          <i class="fas fa-exclamation-triangle"></i>
                      </span>
                      <span v-else title="Нет платного размещения">—</span>
                  </v-td>
                  <v-td name="rating" highlight="*">
                      <div>{{ item.rating }}</div>
                  </v-td>
                  <v-td name="reviews_count" highlight="*">
                      <div>{{ item.reviews_count }}</div>
                  </v-td>
                  <v-td name="extra_info" v-tooltip="item.extra_info && item.extra_info.length > 50 ? item.extra_info : ''">
                      <div class="ellipsis-two-lines">
                          {{ item.extra_info }}
                      </div>
                  </v-td>
              </v-tr>
          </template>
      </v-table>
  </main>
</template>

<script>
export default {
    props: {
        competitorOptions: {
            type: Array,
            required: true
        },
        cityOptions: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            detailLevel: localStorage.getItem(window.location.pathname + '@detailLevel') !== null ? localStorage.getItem(window.location.pathname + '@detailLevel') : '',
        };
    },
    methods: {
        setCreatePeriodFilter(data) {
            if (this.isTableLoaded()) {
                if (data) {
                    this.$refs.table.$data.filter.createdPeriod = data;
                    if (this.$refs.singleDate) {
                        this.$refs.singleDate.$refs.popup.clear();
                    }
                } else {
                    delete this.$refs.table.$data.filter.createdPeriod;
                }
                this.$refs.table.update();
            }
        },
        isTableLoaded() {
            return this.$refs?.table !== undefined;
        },
        clearDateRangePicker() {
            if (this.$refs.singleDate.date && this.$refs.datepicker.end) {
                delete this.$refs.datepicker.clearRange();
            }
        },
        clearPlaceholder() {
            this.$refs.datepicker.clearRange()
        },
    },
}
</script>

<style scoped>
    .ellipsis-two-lines {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .header-filters {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }
</style>
